import { useKeycloak } from "@react-keycloak/web";
import { Button, Form, Input, Select, Space, Switch } from "antd";
import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { useAppSelector } from "../../../../app/store";
import SelectDownIcon from "../../../../assets/icons/SelectDownIcon";
import CardTitle from "../../../../components/common/CardTitle";
import CustomCard from "../../../../components/common/CustomCard";
import ConfirmModal from "../../../../components/ui/ConfirmModal";
import Loader from "../../../../components/ui/Loader";
import { mailRegex } from "../../../../constants/constants";
import { useGetAllCompanyQuery } from "../../../../features/portal/companyOnboard/companyOnboardApi";
import { useGetAllProductQuery } from "../../../../features/portal/Products/productsApi";
import {
  useGetPortalSingleSubDepartmentByIdQuery,
  useGetProtalAllDepartmentQuery,
} from "../../../../features/portal/settings/settingsApi";
import {
  useGetSingleUserQuery,
  useGetUserStatusQuery,
  useUpdateUserStatusMutation,
} from "../../../../features/portal/user/userApi";
import useError from "../../../../hooks/useError";
import useModal from "../../../../hooks/useModal";
import SidebarLayout from "../../../../layouts/SidebarLayout";
import { toast } from "../../../../lib/toast";
import { isValidTLD } from "../../../../utils/utils";

export default function UserDetails() {
  const [selectedDepartmentId, setSelectedDepartmentId] = useState<
    number | null
  >(null);
  const [form] = Form.useForm();
  const { id } = useParams();
  const { keycloak } = useKeycloak();
  const isAdmin2 = keycloak?.realmAccess?.roles?.includes("admin2");
  const backLink = "/admin/users-roll-access/user-list";

  const { open, handleOpen, handleClose } = useModal<boolean>();

  const { user } = useAppSelector((state) => state.auth);

  const { isError, error, data } = useGetAllCompanyQuery({
    params: {
      company_id: isAdmin2 ? user?.data?.company_id : undefined,
      page: 1,
      limit: 1000000000000,
    },
  });

  const {
    isError: isAllProductError,
    error: allProductError,
    data: getAllProduct,
  } = useGetAllProductQuery({});

  const {
    isLoading: isDetailsLoading,
    isError: isDetailsError,
    error: detailsError,
    data: detailsData,
  } = useGetSingleUserQuery(id || "", {
    skip: !id,
  });

  const {
    data: getPortalDepartmentData,
    isError: getPortalDepartmentIsError,
    error: getPortalDepartmentError,
    isLoading: getPortalDepartmentIsLoading,
  } = useGetProtalAllDepartmentQuery({
    params: {
      page: 1,
      limit: 100000,
      is_published: 1,
    },
  });

  const {
    data: getPortalSubDepartmentData,
    isError: getPortalSubDepartmentIsError,
    error: getPortalSubDepartmentError,
    isLoading: getPortalSubDepartmentIsLoading,
  } = useGetPortalSingleSubDepartmentByIdQuery(
    {
      params: {
        skip: undefined,
        page: 1,
        limit: 100000,
        status: true,
        department_id: selectedDepartmentId ?? undefined,
      },
    },
    { skip: !selectedDepartmentId }
  );

  type StatusDataType = {
    data?: {
      status?: string;
      [key: string]: any;
    };
    [key: string]: any;
  };

  const [
    updateUserStatus,
    {
      isError: updateUserStatusIsError,
      error: updateUserStatusError,
      isSuccess: updateUserStatusIsSuccess,
      isLoading: updateUserStatusIsLoading,
    },
  ] = useUpdateUserStatusMutation();
  const {
    data: getStatusData,
    isError: getStatusIsError,
    error: getStatusError,
    isLoading: getStatusIsLoading,
  } = useGetUserStatusQuery(detailsData?.data?.email || "", {
    skip: !detailsData?.data?.email,
  }) as {
    data?: StatusDataType;
    isError: boolean;
    error: any;
    isLoading: boolean;
  };

  useError(isError, error, "Get all company fail");
  useError(isAllProductError, allProductError, "Get all product fail");
  useError(isDetailsError, detailsError, "User details get fail");
  useError(getStatusIsError, getStatusError, "Get user status failed");
  useError(
    updateUserStatusIsError,
    updateUserStatusError,
    "update user status failed"
  );

  const allProduct = getAllProduct?.data?.data;

  const onFinish = (values: any) => {
    console.log("Form values:", values);
  };

  useEffect(() => {
    if (id && detailsData?.data) {
      form.setFieldsValue({
        username: detailsData?.data?.username,
        email: detailsData?.data?.email,
        company_id: detailsData?.data?.company_id,
        department_id: detailsData?.data?.department?.name,
        sub_department_id: detailsData?.data?.sub_department?.name,
      });
    }
  }, [id, detailsData?.data, form]);

  useEffect(() => {
    if (updateUserStatusIsSuccess) {
      toast("success", "Status update successfully");
      handleClose();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updateUserStatusIsSuccess]);

  return (
    <>
      <SidebarLayout
        title={"User Details and Logs"}
        backLink="/admin/users-roll-access/user-list"
      >
        {/* <Form
          className="custom-form"
          layout="vertical"
          requiredMark="optional"
          size="large"
          onFinish={onFinish}
          form={form}
        >
          <CustomCard className=" p-6 pb-0 rounded-b-none">
            <div className="flex items-start gap-3 mb-10">
              <div className="w-1/2">
                <CardTitle>User Info</CardTitle>
                <div className="flex items-center gap-3 mt-5">
                  <div className="h-24 w-24 rounded-full overflow-hidden border border-[#E2E8F0]">
                    <img src={DefaultImage} alt="" />
                  </div>
                  <div>
                    <div className="self-stretch justify-start text-slate-700 text-lg font-semibold">
                      Md Nazmul Hossain
                    </div>
                    <div className="justify-start text-slate-600 text-sm font-medium">
                      Chief Executive Officer (CEO)
                    </div>
                    <div className="justify-start text-slate-600 text-sm font-medium ">
                      Department of{" "}
                      <span className="justify-start text-yellow-500 text-sm font-medium ">
                        Digital Merketing
                      </span>
                    </div>
                    <div className="justify-start text-slate-600 text-sm font-medium ">
                      Email:{" "}
                      <span className="justify-start text-blue-500 text-sm font-medium">
                        name@email.com
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <div className="w-1/2">
                <CardTitle>Assigned Role</CardTitle>
                <div className="mt-5 flex items-center justify-between gap-3">
                  <div className="w-48 justify-start text-blue-600 text-sm font-medium">
                    Digigo HRMS
                  </div>

                  <div className="self-stretch justify-start text-zinc-700 text-sm font-medium ">
                    Account Manager
                  </div>
                </div>
              </div>
            </div>

            <CardTitle>User Log</CardTitle>

            <div className="mt-4 mb-4 space-y-4">
              {logs.map((log, index) => (
                <div key={index} className="relative pl-6">
                  {index !== logs.length - 1 && (
                    <div className="absolute left-2 top-5 w-0.5 h-full border-l-2 border-[#AFBACA] border-dashed"></div>
                  )}

                  <div
                    className={`absolute left-0 w-4 h-4 rounded-full ${
                      statusColors[log.status]
                    }`}
                  ></div>

                  <div className="text-[12px] ml-3">
                    <div className="font-semibold text-gray-600 text-[#C19C60]">
                      {log.time} - {log.date}
                    </div>
                    <p className="text-gray-700 text-display-body text-sm mb-1">
                      {log.message}
                    </p>
                    <div className="text-blue-500  flex items-center">
                      <div className="flex items-center gap-2">
                        <span className="text-[#FE7235] w-4 h-4 inline-flex items-center justify-center">
                          <UserIcon />
                        </span>
                        <span className="text-nowrap italic text-[#8897AE]">
                          {log.user} -{" "}
                        </span>
                      </div>
                      <span className="font-medium text-gray-600 ml-1 text-nowrap italic text-[#8897AE]">
                        {log.role}
                      </span>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </CustomCard>

     
          <div className="p-6 rounded-md rounded-t-none bg-white border border-t-0 border-light">
            <Space className="w-full mt-2" size={12}>
              <Link to={`/admin/users-roll-access/user-list`}>
                <Button
                  className="normal-dark-button modal-button"
                  size="middle"
                >
                  Cancel
                </Button>
              </Link>
              <Link to={`/admin/users-roll-access/user-list/edit/${id}`}>
                <Button className="modal-button" type="primary" size="middle">
                  Edit
                </Button>
              </Link>
            </Space>
          </div>
        </Form> */}

        {open?.type === "CONFIRM" && (
          <ConfirmModal
            open={open?.open}
            handleClose={handleClose}
            handleOk={(checked) => {
              updateUserStatus({
                email: detailsData?.data?.email,
                enabled: checked,
              });
            }}
            data={open?.data}
            okLoading={updateUserStatusIsLoading}
            okText="Confirm"
            cancelText="Cancel"
            confirmTitle="Update Status"
            questionText="Are you sure you want to update the status?"
          />
        )}

        {id && isDetailsLoading ? (
          <Loader />
        ) : (
          <Form
            className="custom-form"
            layout="vertical"
            requiredMark="optional"
            size="large"
            onFinish={onFinish}
            form={form}
          >
            <CustomCard className=" p-6 pb-0 rounded-b-none">
              <CardTitle
                rightSide={
                  !getStatusIsLoading && (
                    <div>
                      <Switch
                        checked={getStatusData?.data?.enabled}
                        disabled={updateUserStatusIsLoading}
                        onChange={(checked) => {
                          handleOpen({
                            type: "CONFIRM",
                            data: checked,
                          });
                        }}
                      />
                    </div>
                  )
                }
              >
                User Info
              </CardTitle>

              <div className="grid lg:grid-cols-3 md:grid-cols-2 sm:grid-cols-1 gap-x-6 pt-4 mb-6">
                <Form.Item
                  label="User Name"
                  name="username"
                  rules={[
                    { required: true, message: "Please enter user name" },
                  ]}
                >
                  <Input
                    placeholder="Enter User Name"
                    allowClear
                    disabled={id ? true : false}
                  />
                </Form.Item>

                <Form.Item
                  label="Email ID"
                  name="email"
                  validateFirst
                  rules={[
                    {
                      required: true,
                      message: "Please enter email id",
                    },
                    {
                      validator: async (_: any, value: string) => {
                        if (!value) {
                          return Promise.resolve();
                        }

                        if (!mailRegex.test(value)) {
                          return Promise.reject(
                            new Error("Please enter a valid email")
                          );
                        }

                        if (!isValidTLD(value)) {
                          return Promise.reject(
                            new Error("Please enter a valid TLD")
                          );
                        }

                        return Promise.resolve();
                      },
                    },
                  ]}
                >
                  <Input
                    placeholder="Enter email id"
                    allowClear
                    disabled={id ? true : false}
                  />
                </Form.Item>

                <Form.Item
                  label="Company Name"
                  name="company_id"
                  rules={[
                    { required: true, message: "Please enter a company name" },
                  ]}
                >
                  <Select
                    placeholder="Company Name"
                    showSearch
                    options={
                      data?.data?.companies?.map((company: any) => ({
                        label: company?.company_name,
                        value: company?.id,
                      })) || []
                    }
                    className="w-full"
                    suffixIcon={<SelectDownIcon />}
                    style={{ width: "100%" }}
                    allowClear
                    optionFilterProp="label"
                    disabled={id ? true : false}
                  />
                </Form.Item>

                <Form.Item
                  label="Department"
                  name="department_id"
                  // rules={[
                  //   {
                  //     required: false,
                  //     message: "Please enter a department",
                  //   },
                  // ]}
                >
                  <Select
                    placeholder="Department"
                    showSearch
                    options={
                      getPortalDepartmentData?.data?.departments?.map(
                        (department: any) => ({
                          label: department?.name,
                          value: department?.id,
                        })
                      ) || []
                    }
                    onChange={(value) => {
                      setSelectedDepartmentId(value || null);
                    }}
                    className="w-full"
                    suffixIcon={<SelectDownIcon />}
                    style={{ width: "100%" }}
                    allowClear
                    optionFilterProp="label"
                    disabled={id ? true : false}
                  />
                </Form.Item>

                <Form.Item
                  label="Sub Department"
                  name="sub_department_id"
                  // rules={[
                  //   {
                  //     required: false,
                  //     message: "Please enter a sub department",
                  //   },
                  // ]}
                >
                  <Select
                    placeholder="Sub Department"
                    showSearch
                    options={
                      getPortalSubDepartmentData?.data?.map(
                        (department: any) => ({
                          label: department?.name,
                          value: department?.id,
                        })
                      ) || []
                    }
                    className="w-full"
                    suffixIcon={<SelectDownIcon />}
                    style={{ width: "100%" }}
                    allowClear
                    optionFilterProp="label"
                    disabled={id ? true : false}
                  />
                </Form.Item>

                {/* <Form.Item
                        name="password"
                        label="Password"
                        rules={[
                          {
                            required: true,
                            message: "Please enter your password",
                          },
                        ]}
                      >
                        <Input.Password placeholder="Password" allowClear />
                      </Form.Item> */}
              </div>

              {/* <CardTitle>
                      Select Products & User Role Group{" "}
                      <span className="cursor-pointer">
                        <AddIcon />
                      </span>
                    </CardTitle>
                    <div className="grid lg:grid-cols-3 md:grid-cols-2 sm:grid-cols-1 gap-x-6 pt-4 mb-6">
                      <Form.Item
                        label="Select Products"
                        name="products"
                        rules={[{ required: true, message: "Please select product" }]}
                      >
                        <Select
                          mode="multiple"
                          placeholder="Select products"
                          //   options={selectStringOption([
                          //     "Product 1",
                          //     "Product 2",
                          //     "Product 3",
                          //     "Product 4",
                          //   ])}
                          className="w-full"
                          suffixIcon={<SelectDownIcon />}
                          style={{ width: "100%" }}
                        />
                      </Form.Item>
        
                      <Form.Item
                        label="Select User Group"
                        name="user_group"
                        rules={[
                          { required: true, message: "Please select user group" },
                        ]}
                      >
                        <Select
                          mode="multiple"
                          placeholder="Select user group"
                          //   options={selectStringOption([
                          //     "Product 1",
                          //     "Product 2",
                          //     "Product 3",
                          //     "Product 4",
                          //   ])}
                          className="w-full"
                          suffixIcon={<SelectDownIcon />}
                          style={{ width: "100%" }}
                        />
                      </Form.Item>
                    </div> */}
            </CustomCard>

            {/* sticky bottom-0 */}
            <div className="p-6 rounded-md rounded-t-none bg-white border border-t-0 border-light">
              <Space className="w-full mt-2" size={12}>
                <Link to={backLink}>
                  <Button
                    className="normal-dark-button modal-button"
                    size="middle"
                  >
                    Cancel
                  </Button>
                </Link>
                <Link
                  to={`/admin/users-roll-access/user-list/edit/${Number(id)}`}
                >
                  <Button
                    className="modal-button"
                    type="primary"
                    htmlType="submit"
                    size="middle"
                  >
                    Edit
                  </Button>
                </Link>
              </Space>
            </div>
          </Form>
        )}
      </SidebarLayout>
    </>
  );
}

const statusColors = {
  success: "bg-green-500",
  warning: "bg-yellow-400",
  error: "bg-red-500",
};

interface LogItem {
  time: string;
  date: string;
  message: string;
  user: string;
  role: string;
  status: "success" | "warning" | "error";
}

const logs: LogItem[] = [
  {
    time: "06:01 PM",
    date: "06 Nov, 2024",
    message: "This Business Activated Successfully!",
    user: "Md Abdul Hamid",
    role: "System Admin",
    status: "success",
  },
  {
    time: "06:01 PM",
    date: "06 Nov, 2024",
    message: "Request to Active This Business",
    user: "Md Abdul Hamid",
    role: "Finance Admin",
    status: "warning",
  },
  {
    time: "06:01 PM",
    date: "06 Nov, 2024",
    message: "This Business Inactivated Successfully!",
    user: "Md Abdul Hamid",
    role: "System Admin",
    status: "error",
  },
  {
    time: "06:01 PM",
    date: "06 Nov, 2024",
    message: "Request to Inactive This Business",
    user: "Md Abdul Hamid",
    role: "Business Team",
    status: "warning",
  },
];
